<template>
	<include-header-main />

	<div id="ocr_loading">사업자등록증 이미지를 인식중입니다.</div>

	<section id="join_form">
		<form ref="form_member_register" id="form_member_register" :action="`${SERVER_URL}/api/app/member/register`"
			@submit.prevent="form_member_register_submit()" method="post" enctype="multipart/form-data"
			autocomplete="off">
			<input type="hidden" v-model="form.mb_hp" id="mb_hp">
			<input type="hidden" v-model="form.cert_no">
			<input type="hidden" v-model="form.hp_cert" id="hp_cert">

			<div :class="['join_inner', join_type]">
				<div class="main_tit"><span>덴탈클라우드</span> {{ register_type }} 회원가입</div>
				<div class="agree_form">
					<div class="agree1">
						<div class="sub_tit">개인정보 수집 및 이용동의</div>
						<div class="agree1_txt" v-html="privacy_text">
						</div>
						<div class="agree1_check">
							<label><input type="checkbox" v-model="form.agree" id="agree" true-value="Y" required="">
								<span>[필수]</span>개인정보 수집 및 이용동의</label>
						</div>
					</div>
					<div class="agree2">
						<div class="sub_tit">덴탈클라우드 이용약관</div>
						<div class="agree2_txt" v-html="agree_text">
						</div>
						<div class="agree2_check">
							<label><input type="checkbox" v-model="form.agree2" id="agree2" true-value="Y" required="">
								<span>[필수]</span>덴탈클라우드 이용약관</label>
						</div>
					</div>
				</div>

				<div :class="['info_form', join_type + '_form']">
					<div class="join_info">
						<div class="sub_tit">
							회원 정보 입력
							<p class="sub_txt">(<span class="essential"></span> 필수입력사항)</p>
						</div>
						<div class="infoForm">
							<table>
								<tbody>
									<tr>
										<td class="memberCols1"><label for="reg_mb_id">아이디<span class="essential"></span></label></td>
										<td class="memberCols2">
											<input type="text" v-model="form.mb_id" id="reg_mb_id" class="wcalc id" placeholder="아이디" required="" minlength="6" maxlength="20" autocomplete="off">
											<input type="button" id="id_check" @click="id_check_submit()" @keyup.enter.prevent="id_check_submit()" class="join_form_btn" value="중복확인">
											<div class="required_info">* 아이디는 6~20자 영문 또는 숫자</div>
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="reg_mb_password">비밀번호<span class="essential"></span></label></td>
										<td class="memberCols2">
											<input type="password" v-model="form.mb_password" id="reg_mb_password" class="w100" placeholder="비밀번호" required="" minlength="8" maxlength="16" autocomplete="new-password">
											<div class="required_info">* 비밀번호는 8~16자 <span class="text-orange">영문, 숫자, 특수문자 필수</span></div>
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="reg_mb_password_re">비밀번호 확인<span class="essential"></span></label></td>
										<td class="memberCols2">
											<input type="password" v-model="form.mb_password_re" id="reg_mb_password_re" class="w100" placeholder="비밀번호 확인" required="" minlength="8" maxlength="16" autocomplete="new-password">
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="reg_mb_name">성명<span class="essential"></span></label></td>
										<td class="memberCols2">
											<input type="text" v-model="form.mb_name" id="reg_mb_name" class="w100" placeholder="성명" required="">
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="mb_email">이메일<span class="essential"></span></label></td>
										<td class="memberCols2">
											<input type="email" v-model="form.mb_email" id="mb_email" class="wcalc" placeholder="이메일" required="" maxlength="50" @input="handleMaxLengthCheck">
											<input type="button" id="reg_mb_email_check" class="join_form_btn" @click="email_check_submit()" value="중복확인">
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="phone1">휴대전화<span class="essential"></span></label>
											<div>
												<small v-show="form.hp_cert === 1 && form.hp_check === 1" class="required changed">
													인증 &check;
												</small>
											</div>
										</td>
										<td class="memberCols2 phone">
											<select v-model="form.phone1" id="phone1" class="phone1" required="" :readonly="form.readonly_phone">
												<option selected="">010</option>
												<option>011</option>
												<option>016</option>
												<option>017</option>
												<option>018</option>
												<option>019</option>
												<option>070</option>
											</select>
											<span class="hyphen">-</span>
											<input type="text" data-type="number" v-model="form.phone2" id="phone2" class="phone2" required="" :readonly="form.readonly_phone" maxlength="4" @input="handleMaxLengthCheck">
											<span class="hyphen">-</span>
											<input type="text" data-type="number" v-model="form.phone3" id="phone3" class="phone3" @keyup.enter.prevent="req_checknum()" required="" :readonly="form.readonly_phone" maxlength="4" @input="handleMaxLengthCheck">
											<input type="button" id="req_checknum_btn" @click="req_checknum()" v-show="!form.readonly_phone && form.show_req_checknum_btn" class="join_form_btn" value="인증번호 발송">
											<div v-if="clientIP === '182.219.119.124'" class="required_info">* [위트리IP에서만 보임] 두번째 칸 첫 숫자를 0,1,2로 시작하면 실제 발송되지 않음 {{ sended_hp }}</div>
										</td>
									</tr>
									<tr id="checknum_wrap" class="checknum_wrap">
										<td class="memberCols1"></td>
										<td class="memberCols2">
											<input type="text" data-type="number" v-model="form.checknum" id="checknum" @keyup.enter.prevent="cert_sms_check()" class="wcalc" placeholder="인증번호 6자리" maxlength="6" @input="handleMaxLengthCheck">
											<input type="button" id="checknum_confirm" @click="cert_sms_check()" class="join_form_btn" value="확인">
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="mb_tel">대표 전화번호<span class="essential"></span></label></td>
										<td class="memberCols2">
											<input type="text" v-model="form.mb_tel" id="mb_tel" class="w100" placeholder="대표 전화번호 입력" required="" maxlength="15" @input="handleMaxLengthCheck">
											<div class="required_info">* 대표 전화번호는 최대 15자 숫자 또는 하이픈(-)</div>
										</td>
									</tr>
									<!-- 240426 추가 [계좌정보 추가 / 기공소페이지에서만 노출] -->
									<tr v-if="mb_type === 'dental_lab'" class="bank_info">
										<td class="memberCols1"><label for="mb_bank">계좌정보<span class="essential"></span></label></td>
										<td class="memberCols2">
											<div><label for="mb_bank">은행명</label><input type="text" v-model="form.mb_bank" id="mb_bank" class="w100" placeholder="은행명 입력" required="" maxlength="50" @input="handleMaxLengthCheck"></div>
											<div><label for="mb_bank_acc">계좌번호</label><input type="text" v-model="form.mb_bank_acc" id="mb_bank_acc" class="w100" placeholder="계좌번호 입력" required="" maxlength="20" @input="handleMaxLengthCheck"></div>
											<div><label for="mb_bank_name">예금주명</label><input type="text" v-model="form.mb_bank_name" id="mb_bank_name" class="w100" placeholder="예금주명 입력" required="" maxlength="15" @input="handleMaxLengthCheck"></div>
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="reg_mb_img">사업자등록증<span class="essential"></span></label></td>
										<td class="memberCols2">
											<!-- <img :src="showPreview()" alt="" style="max-width:100%;" /> -->
											<input type="file" ref="mb_img" id="reg_mb_img" :class="{ 'disabled' : form.mb_img != null }" @change="updatePhoto('mb_img')" class="wcalc" accept="image/jpeg, image/png">
											<input type="button" v-show="form.mb_img != null" @click="resetPhoto" class="join_form_btn" value="삭제">
											<div class="required_info">* png, jpg, jpeg 파일만 등록 가능 (3MB 이하)</div>
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="reg_mb_busi_num">사업자정보<span class="essential"></span></label></td>
										<td class="memberCols2">
											<div><label for="reg_mb_busi_num">사업자등록번호</label><input type="text" v-model="form.mb_busi_num" id="reg_mb_busi_num" class="w100" placeholder="(사업자등록증 업로드시 자동입력) xxx-xx-xxxxx" required="" :readonly="form.readonly_busi" maxlength="12"></div>
											<div><label for="reg_mb_busi_name">상호명</label><input type="text" v-model="form.mb_busi_name" id="reg_mb_busi_name" class="w100" placeholder="(사업자등록증 업로드시 자동입력)" required="" :readonly="form.readonly_busi"></div>
											<div><label for="reg_mb_busi_boss">대표자</label><input type="text" v-model="form.mb_busi_boss" id="reg_mb_busi_boss" class="w100" placeholder="(사업자등록증 업로드시 자동입력)" required="" :readonly="form.readonly_busi"></div>
											<div><label for="reg_mb_busi_addr">소재지</label><input type="text" v-model="form.mb_busi_addr" id="reg_mb_busi_addr" class="w100" placeholder="(사업자등록증 업로드시 자동입력)" required="" :readonly="form.readonly_busi"></div>
										</td>
									</tr>
									<tr>
										<td class="memberCols1"><label for="reg_mb_icon">프로필 사진</label></td>
										<td class="memberCols2">
											<!-- <img :src="showPreview2()" alt="" style="max-width:100%;" /> -->
											<input type="file" ref="mb_icon" id="reg_mb_icon" :class="{ 'disabled' : form.mb_icon != null }" @change="updatePhoto('mb_icon')" class="wcalc" accept="image/gif, image/jpeg, image/png">
											<input type="button" v-show="form.mb_icon != null" @click="resetPhoto2" class="join_form_btn" value="삭제">
											<div class="required_info">* png, jpg, jpeg, gif 파일만 등록 가능 (3MB 이하) / 가로
												300px, 세로 300px 이하 권장</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<button type="button" id="btn_submit" class="join_ok_btn btn_style1"
							@click.prevent="form_member_register_submit()">가입 완료하기</button>
					</div>
				</div>
			</div>
		</form>
	</section>

	<include-footer />
</template>

<script>
import header_main from '../components/layout/header-main.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header-main': header_main,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, onBeforeUnmount, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as registerjs from '@/components/utils/register';

const route = useRoute();
const router = useRouter();

const clientIP = ref(null);

const register_type = ref(null);
const join_type = ref(null);
const agree_text = ref(null);
const privacy_text = ref(null);

const props = defineProps({
	id: {
		type: String,
		required: false
	},
	mb_type: {
		type: String,
		required: false
	},
});

const mb_type = ref(props ? props.mb_type : 'dental_lab');

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const form = ref({
	agree: '',
	agree2: '',
	mb_id: '',
	mb_password: '',
	mb_password_re: '',
	mb_name: '',
	mb_email: '',
	phone1: "010",
	phone2: '',
	phone3: '',
	mb_hp: '',
	sended_hp: "",
	certed_hp: "",
	checknum: '',
	readonly_phone: false,
	cert_no: '',
	mb_tel: '',
	mb_bank: '',
	mb_bank_acc: '',
	mb_bank_name: '',
	mb_busi_num: '',
	mb_busi_name: '',
	mb_busi_boss: '',
	mb_busi_addr: '',
	readonly_busi: true,
	mb_img: null,
	mb_icon: null,
	preview: null,
	preview2: null,
	checked_mb_id: '',
	id_check: 0,
	hp_check: 0,
	hp_cert: 0,
	checked_mb_email: '',
	email_check: 0,
	email_cert: 0,
	timeout: false,
	show_req_checknum_btn: false
});

// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event) {
	maxLengthCheck(event, form); // `form`이 `ref`로 전달됨
}

function handleValueCheck(event) {
	valueCheck(event, form); // `form`이 `ref`로 전달됨
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
	const object = event.target;

	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// 나머지 함수 로직...
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.maxLength) {
		if (object.value.length > object.maxLength) {
			object.value = object.value.slice(0, object.maxLength);
		}
	}

	// `modelName`이 `dataObjectRef.value`에 있는지 확인
	try {
		if (modelName in dataObjectRef.value) {
			dataObjectRef.value[modelName] = object.value; // 데이터 모델 업데이트
			// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
		} else {
			console.debug(`Model '${modelName}' not found in data object.`);
		}
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

function valueCheck(event, dataObjectRef) {
	const object = event.target;

	// 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
	console.log('Received dataObjectRef:', dataObjectRef);

	// `dataObjectRef.value`가 유효한지 확인
	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// `id` 속성을 사용하여 데이터 모델 속성 이름을 추론
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 입력 값이 비어 있는 경우 0으로 설정
	let newValue = object.value.trim();
	if (newValue.length < 1) {
		newValue = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		newValue = parseInt(newValue, 10).toString();
	}

	// DOM 업데이트
	object.value = newValue;

	// Vue 데이터 모델 업데이트
	if (modelName in dataObjectRef.value) {
		dataObjectRef.value[modelName] = newValue;
		// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
	} else {
		console.debug(`Model '${modelName}' not found in data object.`);
	}
}

onMounted(async () => {
	console.log('Initial values:', form.value.phone2, form.value.phone3);

	clientIP.value = await commonjs.getIpAddress();

	//commonjs.DOMLoaded();
	registerjs.DOMLoaded();

	switch (mb_type.value) {
		case 'dental_hospital':
			register_type.value = "치과";
			join_type.value = "join_dental";
			agree_text.value = commonjs.get_common_text('hospital').agree_text;
			privacy_text.value = commonjs.get_common_text('hospital').privacy_text;
			break;

		case 'dental_lab':
			register_type.value = "기공소";
			join_type.value = "join_lab";
			agree_text.value = commonjs.get_common_text('lab').agree_text;
			privacy_text.value = commonjs.get_common_text('lab').privacy_text;
			break;

		default:
			break;
	}

	document.getElementById('reg_mb_img').addEventListener('change', updatePhoto('mb_img'));
	document.getElementById('reg_mb_icon').addEventListener('change', updatePhoto('mb_icon'));
});

onBeforeUnmount(() => {
	document.getElementById('reg_mb_img').removeEventListener('change', updatePhoto('mb_img'));
	document.getElementById('reg_mb_icon').addEventListener('change', updatePhoto('mb_icon'));
});

const previousFileNames = {
	mb_img: '',
	mb_icon: ''
};
let uploadComplete = ref(false);

const updatePhoto = (type) => (e) => {
	const file = e.target.files[0];
	const limit = 1024 * 1024 * 3;
	const validTypes = type === 'mb_img' 
		? ['image/png', 'image/jpeg'] 
		: ['image/gif', 'image/jpeg', 'image/png'];
console.debug('updatePhoto()', type, validTypes.includes(file.type), file.size > limit);
	// 파일이 선택되지 않은 경우
	if (!file) {
		// 파일이 선택되지 않은 경우에도 이전 파일 이름을 유지
		e.target.value = null;
		//e.target.previousFileName = previousFileNames[type]; // 유지할 파일 이름 설정
		return;
	}

	// 파일 타입 및 크기 검증
	if (!validTypes.includes(file.type)) {
		commonjs.uploadSwal('ext');
		e.target.value = '';
		return;
	}

	if (file.size > limit) {
		commonjs.uploadSwal('size');
		e.target.value = '';
		return;
	}
	const reader = new FileReader();
	form.value[type] = file;
	previousFileNames[type] = file.name;

	reader.onloadend = () => {
		const key = type.split('_')[1];

		if (key === 'img') {
			form.value.preview = reader.result;
		} else if (key === 'icon') {
			form.value.preview2 = reader.result;
		}

		uploadComplete.value = true;  // 파일 읽기 완료 시점 설정
	};

	// 파일 읽기 에러 처리
	reader.onerror = () => {
		commonjs.formSwal('파일 읽기 오류', '파일을 읽는 중 오류가 발생했습니다.', `#${type}`, 'self');
	};

	reader.readAsDataURL(file);
};

watch(
	() => [form.value.preview, form.value.preview2], ([nVal, nVal2], [oVal, oVal2]) => {
		if (nVal === undefined || nVal === null) {
		} else {
			if(uploadComplete.value && nVal) {
				if (nVal != oVal && nVal.includes('base64') && (nVal.includes('image/png') || nVal.includes('image/jpeg'))) {
// console.log(nVal.split('base64,')[1]);
					get_OCR_business(nVal.split('base64,')[1]);
				}
			}
		}

		if (nVal2 === undefined || nVal2 === null) {
		} else {
			if (nVal2 != oVal2 && nVal2.includes('base64') && (nVal2.includes('image/png') || nVal2.includes('image/jpeg') || nVal2.includes('image/gif'))) {
console.log('icon file 업로드');
			}
		}
	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

watch(
	() => [form.value.phone2, form.value.phone3], ([nVal, nVal2], [oVal, oVal2]) => {
		if (nVal.length >= 3 && nVal2.length >= 4) {
			console.log('true1');
form.value.show_req_checknum_btn = true;
		} else {
			form.value.show_req_checknum_btn = false;
		}
	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

// 240820 아이디 입력값과 중복체크한 아이디랑 달라지면 다시 중복체크해야됨.
watch(
	() => form.value.mb_id,
	(newVal) => {
		if (newVal === form.value.checked_mb_id) {
			form.value.id_check = 1;
		} else {
			form.value.id_check = 0;
		}
	}
);

// 240820 이메일 입력값과 중복체크한 이메일이랑 달라지면 다시 중복체크해야됨.
watch(
	() => form.value.mb_email,
	(newVal) => {
		if (newVal === form.value.checked_mb_email) {
			form.value.email_check = 1;
			form.value.email_cert = 1;
		} else {
			form.value.email_check = 0;
			form.value.email_cert = 0;
		}
	}
);

const resetPhoto = () => {
	form.value.mb_img = null;
	form.value.preview = null;
	form.value.mb_busi_num = '';
	form.value.mb_busi_name = ''; // 상호
	form.value.mb_busi_boss = ''; // 대표자
	form.value.mb_busi_addr = ''; // 사업장 소재지
	form.value.readonly_busi = true;
	document.getElementById('reg_mb_img').value = null;

	// 파일 이름 초기화
	previousFileNames['mb_img'] = '';
};

const resetPhoto2 = () => {
	form.value.mb_icon = null;
	form.value.preview2 = null;
	document.getElementById('reg_mb_icon').value = null;

	// 파일 이름 초기화
	previousFileNames['mb_icon'] = '';
};

const get_OCR_business = async (file) => {
	// const api_url = "/naver_ocr/custom/v1/33806/51401d9171312ab8267e55a21e526f89261eb76b72eda4afdc4cc6eb484250cd/infer";
  const api_url = "/naver_ocr/custom/v1/27112/3d8a00c0abf2f3ddaabe993ff8c0171a3c50ff6dbfd3e1ad88a27df7af03fbc4/infer";
  // const SECRET_KEY = "Z05MaXRVQkdsTlBxYlhOb0RkTFdnak1GZ3lGWXJ6T0Q=";
  const SECRET_KEY = "eEdOS1JsQWdjb3ZuV2lTWHRmdlJXSnBWbW55T0FvVUY=";
	// const TEMPLATE = ['31778']; // 사업자등록증
  const TEMPLATE = ['27573']; // 사업자등록증

	const api_headers = {
		"Content-Type": "application/json",
		"X-OCR-SECRET": SECRET_KEY,
	};

	const timestamp = Date.now(); // 현재 타임스탬프를 사용합니다
	const data = {
		images: [
			{
				format: "jpg",
				name: "wetree",
				data: file,
				templateIds: TEMPLATE
				//url: "http://dentalcloud.kr/data/order/f8eb7e5de2f5077b7c80f8c6a57d9840.jpg",
			}
		],
		lang: "ko",
		requestId: "guide-json-demo",
		timestamp: timestamp,
		version: "V2"
	};

	const loadingElement = document.getElementById('ocr_loading');

	try {
		loadingElement.style.display = 'block'; // 로딩바 표시
		const response = await axios.post(api_url, data, {
			headers: api_headers
		});

console.debug('get_OCR_business().response.data', response.data);
		if (response.data?.images) {
			if( response.data?.images[0].inferResult === "SUCCESS") {
				form.value.mb_busi_num = response.data?.images[0].fields[0].inferText; // 등록번호
				form.value.mb_busi_name = response.data?.images[0].fields[1].inferText; // 상호
				form.value.mb_busi_boss = response.data?.images[0].fields[2].inferText; // 대표자
				// // const busi_ceo = response.data?.images[0].fields[3].inferText; // 개업연월일
				// // const busi_ceo = response.data?.images[0].fields[4].inferText; // 법인등록번호
				form.value.mb_busi_addr = response.data?.images[0].fields[5].inferText; // 사업장 소재지
				form.value.readonly_busi = false;
			} else {
				commonjs.formSwal('사업자등록증 OCR 오류', '사업자등록증 인식 오류입니다.', '#reg_mb_img', 'self');
				resetPhoto();
			}
		} else {
			//console.log(response.data?.images?.[0]?.message);
			commonjs.formSwal(`사업자등록증 OCR 오류`, `사업자등록증 양식에 맞지 않는 이미지입니다.`, `#reg_mb_img`, `self`);
			resetPhoto();
		}
	} catch (error) {
console.error('get_OCR_business()', error);
		commonjs.formSwal(`사업자등록증 OCR 오류`, `사업자등록증 OCR 요청 중 오류가 발생했습니다.`, `#reg_mb_img`, `self`);
		resetPhoto();
	} finally {
		loadingElement.style.display = 'none'; // 로딩바 숨기기
	}
}

function sms_timer(mode) {
	timeout = false;
	var time = 300;
	var min = "";
	var sec = "";
	var x = setInterval(function () {
		min = parseInt(time / 60);
		sec = time % 60;
		document.getElementById("sms_timer").innerHTML = min + "분" + sec + "초";
		time--;

		if (time < 0) {
			clearInterval(x);
			document.getElementById("sms_timer").innerHTML = "시간 초과";
			timeout = true;
		}
	}, 1000);
}

const send_sms_to_phone = async (cert_hp, cert_code) => {
	let response_pre = await axios.get(`${SERVER_URL}/api/app/member/get_sms_maxid`);
	const sms_maxid = response_pre.data.result.max_id ? response_pre.data.result.max_id : 0;

	const api_url = "/hyphen/mn0109000725"; // 프록시를 사용한 URL
	const api_headers = {
		"Content-Type": "application/json",
		"user-id": "wetreecorp",
		"Hkey": "486c875fb8f848dd"
	};

	const data = {
		SEQ: `dencl-cert${sms_maxid}`,
		RECEIVER: cert_hp,
		SENDER: '07077881458',
		REQ_USER_ID: 'wetreecorp',
		REQ_DEPT_ID: 'hyphen',
		JONMUN: `[덴탈클라우드] 인증번호: ${cert_code} 인증번호를 입력해 주세요.`,
		AD_FLAG: 'N'
	};

	try {
		const response = await axios.post(api_url, data, {
			headers: api_headers
		});
console.debug(response.data); // 인증번호 발송
		if (response.data && response.data.common.errYn === 'N') {
			//document.getElementById("req_checknum_btn").classList.remove('on');
			form.value.show_req_checknum_btn = false;
			document.getElementById('checknum_wrap').classList.add('on');
			document.getElementById('checknum').classList.add('on');

			commonjs.formSwal('인증번호 발송 완료', '휴대전화로 인증번호를 발송했습니다.');
		} else {
console.debug(response.data);
			//document.getElementById("req_checknum_btn").classList.remove('on');
			form.value.show_req_checknum_btn = true;
			document.getElementById('checknum_wrap').classList.remove('on');
			document.getElementById('checknum').classList.remove('on');

			commonjs.formSwal('인증번호 발송 오류', 'SMS 발송중 오류가 발생했습니다. \n(' + response.data.data.message + ')', '#phone2', 'self');
		}
	} catch (error) {
console.error(error?.response?.data);
		commonjs.formSwal('인증번호 발송 요청 오류', 'SMS 발송 요청 중 오류가 발생했습니다.', '#phone2', 'self');
	}
}

const cert_sms_check = async () => {
	await withSubmitFlag(async () => {
		const params = new URLSearchParams();
		params.append('cert_hp', form.value.sended_hp);
		params.append('cert_code', form.value.checknum);
		// 240730 인증패스할때 파라미터 추가함
		let p2_num = parseInt(String(form.value.phone2).slice(0, 1));
		if (typeof p2_num === 'number' && p2_num > 2 && form.value.phone1 === '010') {
		} else {
			params.append('wetree', 'pass');
		}

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/member/cert_sms_check`, params);

			if (response.data.result.check) {
				const hp_arr = form.value.sended_hp.split('-');
				form.value.phone1 = hp_arr[0];
				form.value.phone2 = hp_arr[1];
				form.value.phone3 = hp_arr[2];

				form.value.hp_cert = 1;
				form.value.hp_check = 1;
				form.value.readonly_phone = true;
				form.value.mb_hp = form.value.sended_hp;
				form.value.certed_hp = form.value.mb_hp;
				document.getElementById('checknum_wrap').classList.remove('on');
				form.value.show_req_checknum_btn = false;
				//document.getElementById('req_checknum_btn').classList.remove('on');

				document.getElementById('checknum_confirm').classList.remove('on');

				commonjs.formSwal('인증완료', '휴대전화 인증이 완료되었습니다.');
			} else {
				form.value.hp_cert = 0;
				form.value.hp_check = 0;
				form.value.readonly_phone = false;
				document.getElementById('checknum_wrap').classList.add('on');
				form.value.show_req_checknum_btn = true;
				//document.getElementById('req_checknum_btn').classList.add('on');

				document.getElementById('checknum_confirm').classList.add('on');

				commonjs.formSwal('인증실패', '정확한 인증번호를 입력해 주세요.', '#checknum', 'self');
			}

		} catch (error) {
	console.error(error?.response?.data);
			commonjs.formSwal('인증번호 요청 오류', '데이터 요청중 오류가 발생했습니다.', '#phone2', 'self');
		}
	});
}

const id_check_submit = async () => {
	var result = await registerjs.id_check(document.getElementById("reg_mb_id").value);
console.log(result);

	if (result === 'able') {
		form.value.id_check = 1;
		Swal.fire({
			title: '사용 가능',
			text: '[' + document.getElementById('reg_mb_id').value + '] 사용가능한 아이디입니다',
			icon: 'success',
			confirmButtonText: '확인',
			allowOutsideClick: false,  // 외부 클릭 방지
			allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: false,
		}).then((result) => {
			if (result.isConfirmed) {
				setTimeout(function () {
					document.getElementById('reg_mb_password').focus();
				}, 100);
			}
		});
	} else {
		form.value.id_check = 0;
		var txt = '';
		var tit = '';
		if (result === 'exist') {
			tit = '사용 불가';
			txt = '이미 사용중인 아이디입니다';
		} else {
			tit = '아이디 입력 오류';
			txt = result;
		}

		Swal.fire({
			title: tit,
			text: txt,
			icon: 'error',
			confirmButtonText: '확인',
			// allowOutsideClick: false,  // 외부 클릭 방지
			// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: true,
		});
	}
}

const req_checknum = async () => {
	await withSubmitFlag(async () => {
		if (form.value.show_req_checknum_btn && !form.value.readonly_phone) {
			console.log('req_checknum().if-pass');
			form.value.show_req_checknum_btn = false;
			setTimeout(() => {
				form.value.show_req_checknum_btn = true;
			}, 2000);

			try {
				await send_req();
			} catch (error) {
			console.error(error?.response?.data);
				commonjs.formSwal('인증번호 요청 오류', '데이터 요청중 오류가 발생했습니다.', '#phone2', 'self');
			}
		} else {
			return false;
		}
	});
}

const send_req = async () => {
	const v = form.value.phone1 + form.value.phone2 + form.value.phone3;
	form.value.sended_hp = `${form.value.phone1}-${form.value.phone2}-${form.value.phone3}`;
	
	const params = new URLSearchParams();
	params.append('cert_hp', v);
	params.append('mb_hp', form.value.sended_hp);
	if (globaljs.mb_id) {
		params.append('mb_id', globaljs.mb_id);
	}

console.log('send_req().ready');

	try {
		const response = await axios.post(`${SERVER_URL}/api/app/member/cert_sms_req`, params);
console.log('send_req().response', response);
		if (response.data.result.cert_code) {
			let p2_num = parseInt(String(form.value.phone2).slice(0, 1));

			if (typeof p2_num === 'number' && p2_num > 2 && form.value.phone1 === '010') {
				await send_sms_to_phone(v, response.data.result.cert_code);
			} else {
console.log('[개발자모드] 인증번호:' + response.data.result.cert_code);
				//document.getElementById("req_checknum_btn").classList.remove('on');
				form.value.show_req_checknum_btn = false;
				document.getElementById('checknum_wrap').classList.add('on');
				document.getElementById('checknum').classList.add('on');

				form.value.checknum = response.data.result.cert_code;
				document.getElementById("checknum_confirm").classList.add("on");
				setTimeout(function () {
					// document.getElementById("checknum_confirm").click();
				}, 300);
			}
		} else {
			form.value.show_req_checknum_btn = true;
			document.getElementById('checknum_wrap').classList.remove('on');
			document.getElementById('checknum').classList.remove('on');
			commonjs.formSwal('전송 실패', '오류가 발생해서 전송에 실패했습니다.' + response.data.result.message, '#phone2', 'self');
		}

	} catch (error) {
console.error(error?.response?.data);
		commonjs.formSwal('인증번호 요청 오류', '데이터 요청중 오류가 발생했습니다.', '#phone2', 'self');
	}
}

const email_check_submit = async () => {
	await withSubmitFlag(async () => {
		try {
			let result = await registerjs.email_check(form.value.mb_email);
		
			if (result === 'able') {
				form.value.email_cert = 1;
				form.value.email_check = 1;
				Swal.fire({
					title: '사용 가능',
					text: '[' + document.getElementById('mb_email').value + '] 사용가능한 이메일입니다',
					icon: 'success',
					confirmButtonText: '확인',
					allowOutsideClick: false,  // 외부 클릭 방지
					allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					returnFocus: false,
				}).then((result) => {
					if (result.isConfirmed) {
						setTimeout(function () {
							document.getElementById('phone1').focus();
						}, 100);
					}
				});
			} else {
				form.value.email_cert = 0;
				form.value.email_check = 0;
				let txt = '';
				let tit = '';
				if (result === 'exist') {
					tit = '사용 불가';
					txt = '이미 사용중인 이메일입니다';
				} else {
					tit = '이메일 입력 오류';
					txt = result;
				}
		
				Swal.fire({
					title: tit,
					text: txt,
					icon: 'error',
					confirmButtonText: '확인',
					// allowOutsideClick: false,  // 외부 클릭 방지
					// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					returnFocus: true,
				});
			}
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}

async function form_member_register_submit() {
	await withSubmitFlag(async () => {
		if (form.value.agree !== 'Y') {
			commonjs.formSwal('동의 필요', '개인정보 수집 및 이용에 동의 하셔야 합니다.', '#agree', 'self');
			return false;
		}
		if (form.value.agree2 !== 'Y') {
			commonjs.formSwal('동의 필요', '덴탈클라우드 이용약관에 동의 하셔야 합니다.', '#agree2', 'self');
			return false;
		}
		// if (!registerjs.idRule.test(form.value.mb_id)) {
			// commonjs.formSwal('아이디', '아이디', '#reg_mb_id', 'type');
			// return false;
		// }
		if (form.value.id_check === 0) {
			commonjs.formSwal('아이디', '아이디', '#reg_mb_id', 'exist');
			return false;
		}
		if (!registerjs.pwdRule.test(form.value.mb_password)) {
			commonjs.formSwal('비밀번호', '비밀번호', '#reg_mb_password', 'type');
			return false;
		}
		if (!registerjs.pwdRule.test(form.value.mb_password_re)) {
			commonjs.formSwal('비밀번호 확인', '비밀번호', '#reg_mb_password_re', 'type');
			return false;
		}
		if (form.value.mb_password != form.value.mb_password_re) {
			commonjs.formSwal('비밀번호 입력 오류', '비밀번호가 서로 다릅니다.', '#reg_mb_password', 'self');
			return false;
		}
		if (!form.value.mb_name || form.value.mb_name.length < 1) {
			commonjs.formSwal('성명', '성명', '#reg_mb_name');
			return false;
		}
		if (form.value.email_check === 0) {
			commonjs.formSwal('이메일', '이메일', '#mb_email', 'exist');
			return false;
		}
		if (form.value.hp_check === 0) {
			commonjs.formSwal('휴대전화', '휴대전화', '#phone3', 'cert');
			return false;
		}
		if (!registerjs.phone2Rule.test(form.value.phone2)) {
			commonjs.formSwal('휴대전화번호', '휴대전화번호 가운데 자리(숫자3~4자리)', '#phone2', 'type');
			return false;
		}
		if (!registerjs.phone3Rule.test(form.value.phone3)) {
			commonjs.formSwal('휴대전화번호', '휴대전화번호 끝자리(숫자4자리)', '#phone3', 'type');
			return false;
		}

		if (form.value.certed_hp && form.value.certed_hp.length > 0) {
			if (form.value.mb_hp != form.value.certed_hp) {
				commonjs.formSwal('휴대전화번호', '새로 인증한 번호가 다릅니다. 다시 인증해주세요.', '#phone2', 'self');
			}
			form.value.mb_hp = form.value.certed_hp;
		}

		if (!form.value.mb_tel || form.value.mb_tel.trim().length < 1) {
			commonjs.formSwal('대표 전화번호', '대표 전화번호', '#mb_tel');
			return false;
		}

		form.value.hp_cert = 1;
		form.value.email_cert = 1;

		if (mb_type.value === 'dental_lab') {
			if (!form.value.mb_bank || form.value.mb_bank.length < 1) {
				commonjs.formSwal('은행명', '은행명', '#mb_bank');
				return false;
			}
			if (!form.value.mb_bank_acc || form.value.mb_bank_acc.trim().length < 1) {
				commonjs.formSwal('계좌번호', '계좌번호', '#mb_bank_acc');
				return false;
			}
			if (!form.value.mb_bank_name || form.value.mb_bank_name.length < 1) {
				commonjs.formSwal('예금주명', '예금주명', '#mb_bank_name');
				return false;
			}
		}

		if (!form.value.mb_img || form.value.mb_img.length < 1) {
			commonjs.formSwal('사업자등록증', '사업자등록증', '#reg_mb_img');
			return false;
		}

		//if (!form.value.mb_busi_num || form.value.mb_busi_num.trim().length < 1) {
		if (!registerjs.busiRule.test(form.value.mb_busi_num)) { // 240909 사업자등록번호 유효성 추가(단순버전)
			commonjs.formSwal('사업자등록번호', '사업자등록번호', '#reg_mb_busi_num', 'type');
			return false;
		}
		if (!form.value.mb_busi_name || form.value.mb_busi_name.length < 1) {
			commonjs.formSwal('상호명', '상호명', '#reg_mb_busi_name');
			return false;
		}
		if (!form.value.mb_busi_boss || form.value.mb_busi_boss.length < 1) {
			commonjs.formSwal('대표자', '대표자', '#reg_mb_busi_boss');
			return false;
		}
		if (!form.value.mb_busi_addr || form.value.mb_busi_addr.length < 1) {
			commonjs.formSwal('소재지', '소재지', '#reg_mb_busi_addr');
			return false;
		}

		const formData = new FormData();
		formData.append("mb_type", mb_type.value);
		formData.append("mb_id", form.value.mb_id);
		formData.append("mb_password", form.value.mb_password);
		formData.append("mb_password_re", form.value.mb_password_re);
		formData.append("mb_name", form.value.mb_name);
		formData.append("mb_email", form.value.mb_email);
		formData.append("email_cert", form.value.email_cert);
		formData.append("email_check", form.value.email_check);
		formData.append("mb_hp", form.value.mb_hp);
		formData.append("hp_cert", form.value.hp_cert);
		formData.append("hp_check", form.value.hp_check);
		formData.append("mb_tel", form.value.mb_tel);
		if (mb_type.value === 'dental_lab') {
			formData.append("mb_bank", form.value.mb_bank);
			formData.append("mb_bank_acc", form.value.mb_bank_acc);
			formData.append("mb_bank_name", form.value.mb_bank_name);
		}
		formData.append("mb_busi_num", form.value.mb_busi_num);
		formData.append("mb_busi_name", form.value.mb_busi_name);
		formData.append("mb_busi_boss", form.value.mb_busi_boss);
		formData.append("mb_busi_addr", form.value.mb_busi_addr);
		if (form.value.mb_img != '') {
			formData.append("mb_img", form.value.mb_img);
		}
		if (form.value.mb_icon != '') {
			formData.append("mb_icon", form.value.mb_icon);
		}

		// URLSearchParams를 객체로 변환
		const object = {};
		formData.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		const config = {
			headers: {
				"Content-Type": "multipart/form-data"
			},
		};

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/member/register`, formData, config);
	console.debug(response.data.result);
			router.push("/register_complete");
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>
<style>
/* 로딩바 스타일 */
#ocr_loading {
	display: none;
	/* 초기에는 숨김 */
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	/* 배경 투명도 */
	z-index: 9999;
	text-align: center;
	color: white;
	font-size: 30px;
	padding-top: 20%;
}
</style>
